var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgTick = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 17.86 17.86"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.91,2.16,5.63,12.43,1.86,8.66a.47.47,0,0,0-.67,0L.09,9.76a.47.47,0,0,0,0,.66L5.3,15.64a.47.47,0,0,0,.66,0L17.68,3.93a.48.48,0,0,0,0-.67l-1.1-1.1a.48.48,0,0,0-.67,0Z"
})));
export default SvgTick;